module.exports = __webpack_public_path__ + "img/violet_143.96aa5564.png";